export class CampaignInformationSectionBlock {
  constructor() {
    this.init();
  }

  init() {
    const informationSections: NodeListOf<Element> = document.querySelectorAll('.campaign-information-section-block');
    informationSections.forEach((component) => {
      const items = component.querySelectorAll('.information-item') as NodeListOf<HTMLElement>;

      items.forEach((item) => {
        this.setupItem(item);
      });
    });
  }

  setupItem(item: Element) {
    item.classList.add('transition')
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          entry.target.classList.add('active');
        }
      });
    }, {
      threshold: 0.5
    });
    observer.observe(item);
  }
}
